import { useNavigate } from 'react-router-dom';
import { ApplicationModal } from '../components/ApplicationModal';

const FORM_MAP = {
  'kurye-basvuru-formu': 'courier',
  'restoran-basvuru-formu': 'restaurant',
  'sirket-basvuru-formu': 'company',
};

export default function ApplicationFormPage({ formSlug }) {
  const navigate = useNavigate();
  const formType = FORM_MAP[formSlug] || 'courier';

  return (
    <div className="min-h-screen bg-background" data-testid="application-form-page">
      <ApplicationModal
        isOpen={true}
        onClose={() => navigate('/')}
        defaultForm={formType}
      />
    </div>
  );
}
